<template>
  <div class="card-ecommend">
    <header>
      <img src="../../assets/images/card-img/card-ecommend-img/icon-24-fanhui.png" alt="" @click="$router.replace('/')"> 
      <p>
        卡权益
      </p>
    </header>
    <section>
      <!-- 卡片 -->
      <div class="card-show">
        <div>
          <img src="../../assets/images/card-img/card-ecommend-img/card.png" alt="">
        </div>
      </div>
      <!-- 卡权益 -->
      <div class="card-quanyi">
        <!-- 标题 -->
        <p class="card-quanyi-title">
          <span></span>专享权益
        </p>
        <p class="flash-sales">
          <img src="../../assets/images/card-img/card-ecommend-img/icon-laba.png" alt="">
          【限时特惠】截止本月31号之前，仅需99元可享本卡永久使用权
        </p>
        <div class="card-recommend">
          <p>
            1、KFM康养卡会员费99元（全国统一价），有效期三年;限2020年4月30日前办理可成为永久会员。
          </p>
          <p>
            2、获赠康富美来度假酒店会员资格；入住全国康富美来度假酒店（或公寓）可免押金（有效期3年）。
          </p>
          <p>
            3、获赠全球精英网会员资格；免费获得就业直通车和兼职赚外快的渠道。
          </p>
          <p>
            4、获赠康田互助会员资格；获赠价值100万元的癌症重症互助保障（有效期3年）。
          </p>
          <p>
            5、获赠心灵上医会员资格；获赠价值1万元的私人医生线上咨询服务（有效期3年）。
          </p>
          <p>
            6、获赠旅居大礼包：入住世界长寿之乡--海南澄迈康富美来红树湾度假公寓，享特惠价3000元/月/人（包食宿）。
          </p>
          <p>
            7、KFM康养卡实行备案制；会员卡有增值功能，符合条件会员卡资格可转让、可继承。
          </p>
        </div>
      </div>
    </section>
    <footer>
      <div class="card-payment">
        <span>限时特惠</span>
        <span>99</span>
        <span>元/年</span>
        <span @click="$router.replace('/buy-card')">立即抢购</span>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  data(){
    return{
      card_msg: []
    }
  },

  created(){
    this.$axios.get('/api/card/index/detail?id=1').then((res) =>{
      console.log(res.data.data)
      this.card_msg = res.data.data
    })
  },
  methods:{
    
  }
}
</script>
<style lang="less" scoped>
  .card-ecommend{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
      }
    }
    section{
      width: 100%;
      flex: 1;
      overflow: scroll;
      // 卡片展示
      .card-show{
        width: 100%;
        height: 5.16rem;
        background: #F4F4F4;
        overflow: hidden;
        div{
          width: 6.9rem;
          height: 4.43rem;
          margin: 0 auto;
          margin-top: .23rem;
        }
        img{
          width: 6.9rem;
          height: 4.43rem;
        }
      }
      // 卡权益
      .card-quanyi{
        width: 100%;
        // 卡权益标题
        .card-quanyi-title{
          display: flex;
          align-items: center;
          font-family: PingFang-SC-Bold;
          font-weight: Bold;
          color: #333333;
          font-size: 0.32rem;
          margin-left: .3rem;
          margin-top: .23rem;
          span{
            display: inline-block;
            width: .06rem;
            height: .38rem;
            background: #EF8201;
            margin-right: .21rem;
          }
        }
        // 限时特惠
        .flash-sales{
          margin-left: .29rem;
          font-family: PingFang-SC-Regular;
          font-size: 0.2rem;
          color: #CB852C;
          margin-top: .18rem;
          margin-bottom: .12rem;
          img{
            width: .29rem;
            height: .25rem;
          }
        }
        // 卡介绍
        .card-recommend{
          width: 100%;
          font-family: PingFang-SC-Regular;
          color: #666666;
          font-size: 0.24rem;
          // display: flex;
          // flex-direction: column;
          // overflow: scroll;
          p{
            margin: .16rem .32rem .16rem .3rem;
            line-height: .36rem;
          }
        }
      }
    }
    footer{
      // 抢购
      .card-payment{
        width: 100%;
        height: .98rem;
        // display: flex;
        // align-items: center;
        span{
          &:first-child{
            font-family: PingFang-SC-Bold;
            font-weight: Bold;
            color: #333333;
            font-size: 0.28rem;
            margin-left: .32rem;
          }
          &:nth-child(2){
            font-family: PingFang-SC-Bold;
            font-weight: Bold;
            color: #EB6D00;
            font-size: 0.56rem;
            margin-left: .3rem;
          }
          &:nth-child(3){
            font-family:  PingFang-SC-Bold;
            font-weight: Bold;
            color: #666666;
            font-size: 0.24rem;
            margin-left: .1rem;
          }
          &:last-child{
            display: inline-block;
            width: 2.21rem;
            height: .58rem;
            background: #EB6D00;
            font-family: PingFang-SC-Bold;
            font-weight: Bold;
            color: #FFFFFF;
            text-align: center;
            line-height: .58rem;
            border-radius: .29rem;
            float: right;
            margin-right: .3rem;
            margin-top: .2rem;
          }
        }
      }
    }
  }
</style>